<template>
  <div class="sc-radio-container">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ScRadioInput'
}
</script>

<style scoped lang="scss">
.sc-radio-container {
  label {
    display: inline-block;
    cursor: pointer;
    position: relative;
    padding-left: 35px;
    font-size: $sc-radioinput-label-font-size;
    user-select: none;
  }

  input[type=radio] {
    display: none;
  }

  input[type=radio]:disabled + label:before {
    background-color: $sc-disabled-input-bg;
    cursor: auto;
  }

  input[type=radio]:disabled + label {
    opacity: $sc-disabled-input-opacity;
    cursor: auto;
  }

  label:before {
    content: "";
    display: inline-block;
    width: 20px;
    height: 20px;
    position: absolute;
    left: 0;
    top: -3px;
    border: 1px solid $sc-radioinput-radio-button-border-color;
    border-radius: 50%;
  }

  input[type=radio]:checked + label:before {
    content: "\2022";
    color: $sc-primary;
    font-size: 41px;
    text-align: center;
    line-height: 19px;
  }
}
</style>
